/* Grabatee QR Sticker Studio v1.1 (2026-08-28)
   v1.1: free downloads carry attribution — both PNGs gain tEXt metadata
   (pixels unchanged), the SVG gains a deletable #Info credit line outside
   the QR quiet zone. The order hand-off is byte-identical to v1.0.
   -----------------------------------------------------------------------------
   Free STATIC QR generator + sticker designer. Everything runs in the browser:
   no QR data is sent anywhere by this script. The only network activity is
   the customer's own navigation to the matching sticker product page when
   they choose to order.

   Architecture (see section comment in grab-qr-studio.liquid):
     • Encoding: vendored qrcode-generator (MIT) → module matrix.
     • Layout engine: one pure function builds sticker geometry in INCHES,
       then preview and export both rasterize it at their own pixel density.
       The QR symbol always keeps a 4-module quiet zone inside its own square
       and is never scaled non-uniformly; artwork/caption live in separate
       bands and cannot enter the QR square.
     • Hand-off: "Order these stickers" rasterizes the design at 300 DPI,
       stores it in sessionStorage, and sends the customer to the existing
       Grabatee product page for the chosen shape. assets/qr-handoff.js on
       that page feeds it into the unchanged sticker customizer. Pricing,
       approval, Uploadery, and cart are the existing production path.
   ----------------------------------------------------------------------------- */
(function () {
  "use strict";

  var root = document.getElementById("grab-qr-studio");
  if (!root || typeof window.qrcode !== "function") return;
  var $ = function (id) { return document.getElementById(id); };
  var qrlib = window.qrcode;
  if (qrlib.stringToBytesFuncs && qrlib.stringToBytesFuncs["UTF-8"]) {
    qrlib.stringToBytes = qrlib.stringToBytesFuncs["UTF-8"];
  }

  /* ══ 1. Configuration — sizes mirror the sticker customizer's canonical
     Shopify "Size" option values (sticker-customizer.js SIZE_OPTIONS). Keep
     these lists in sync if the products' Size options ever change. ══ */
  var SHAPES = {
    square:    { label: "Square",     sizes: [["2x2",2,2],["3x3",3,3],["4x4",4,4],["5x5",5,5],["6x6",6,6],["7x7",7,7]] },
    rectangle: { label: "Rectangle",  sizes: [["2x1.2",2,1.2],["3x1.8",3,1.8],["4x2.4",4,2.4],["5x3",5,3],["6x3.6",6,3.6],["7x4.2",7,4.2]] },
    circle:    { label: "Circle",     sizes: [["2x2",2,2],["3x3",3,3],["4x4",4,4],["5x5",5,5],["6x6",6,6],["7x7",7,7]] },
    oval:      { label: "Oval",       sizes: [["2x1.33",2,1.33],["3x2",3,2],["4x2.67",4,2.67],["5x3.34",5,3.34],["6x4",6,4],["7x4.67",7,4.67]] },
    "die-cut": { label: "Die cut",    box: true, sizes: [["Up to 2x2",2,2],["Up to 3x3",3,3],["Up to 4x4",4,4],["Up to 5x5",5,5],["Up to 6x6",6,6],["Up to 7x7",7,7]] },
    "kiss-cut":{ label: "Kiss cut",   box: true, sizes: [["Up to 2x2",2,2],["Up to 3x3",3,3],["Up to 4x4",4,4],["Up to 5x5",5,5],["Up to 6x6",6,6],["Up to 7x7",7,7]] }
  };
  var DEFAULT_SIZE_INDEX = 1;
  var EXPORT_DPI = 300;
  var SAFE_MARGIN_IN = 0.125;      /* keep QR + caption this far from the cut */
  var MIN_MODULE_IN = 0.4 / 25.4;  /* 0.4 mm module pitch — below this most
                                      phone cameras struggle at normal distance */
  var INK = "#17171B";
  var BG_SWATCHES = ["#FFFFFF", "#F2F0EC", "#E6F7FD", "#FFF6CC", "#FDE8F1", "#E9F7EF"];

  /* Product handles + from-prices come from section settings (data attrs). */
  var PRODUCTS = {};
  try { PRODUCTS = JSON.parse(root.getAttribute("data-products") || "{}"); } catch (e) { PRODUCTS = {}; }

  /* ══ 2. State ══ */
  var S = {
    qrType: "url",
    fields: {},
    payload: "",
    qr: null, modules: 0, ecc: "M",
    shape: "square", sizeValue: "3x3", w: 3, h: 3,
    logo: null, logoName: "", logoDataURL: "",
    caption: "", captionEnabled: true,
    bg: "#FFFFFF",
    layout: "auto",  /* auto | stack | side */
    verified: null   /* null = untested, true/false */
  };

  /* ══ 3. Payload builders + validation ══ */
  var FIELD_DEFS = {
    url:   [["url","Website address","url","https://yourbusiness.com",true]],
    text:  [["text","Text or message","textarea","Anything you want people to read when they scan",true]],
    email: [["email","Email address","email","hello@yourbusiness.com",true],["subject","Subject","text","Optional",false],["body","Message","textarea","Optional",false]],
    phone: [["phone","Phone number","tel","+1 555 123 4567",true]],
    sms:   [["phone","Phone number","tel","+1 555 123 4567",true],["message","Message","textarea","Optional — pre-fills the text message",false]],
    wifi:  [["ssid","Network name (SSID)","text","Exactly as it appears on your router",true],["security","Security","select",["WPA","WPA/WPA2","WEP","WEP","nopass","No password"],true],["password","Password","password","",false],["hidden","Hidden network","checkbox","",false]],
    vcard: [["first","First name","text","",true],["last","Last name","text","",false],["org","Company","text","",false],["title","Job title","text","",false],["phone","Phone","tel","",false],["email","Email","email","",false],["url","Website","url","",false],["street","Street address","text","",false],["city","City","text","",false],["state","State / region","text","",false],["zip","Postal code","text","",false],["country","Country","text","",false]]
  };
  var TYPE_LABELS = { url: "Website URL", text: "Text", email: "Email", phone: "Phone", sms: "Text message (SMS)", wifi: "Wi-Fi", vcard: "Contact card (vCard)" };

  function trim(v) { return String(v == null ? "" : v).trim(); }
  function normalizeUrl(raw) {
    var v = trim(raw);
    if (!v) return null;
    if (!/^[a-z][a-z0-9+.-]*:/i.test(v)) v = "https://" + v;
    try {
      var u = new URL(v);
      if (!/^https?:$/.test(u.protocol)) return null;
      if (!u.hostname || u.hostname.indexOf(".") < 0) return null;
      return u.href;
    } catch (e) { return null; }
  }
  function validEmail(v) { return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v); }
  function normalizePhone(raw) {
    var v = trim(raw).replace(/[\s().-]/g, "");
    if (!/^\+?\d{5,20}$/.test(v)) return null;
    return v;
  }
  function wifiEscape(v) { return String(v).replace(/([\\;,":])/g, "\\$1"); }
  function vEsc(v) { return String(v).replace(/\\/g, "\\\\").replace(/\n/g, "\\n").replace(/,/g, "\\,").replace(/;/g, "\\;"); }

  /* Returns { payload, errors:{field:msg}, summary } — summary is the
     non-sensitive description later attached to the order. */
  function buildPayload(type, f) {
    var errors = {}, payload = "", summary = "";
    switch (type) {
      case "url": {
        var u = normalizeUrl(f.url);
        if (!u) errors.url = trim(f.url) ? "That doesn't look like a web address. Try something like yourbusiness.com" : "Enter the web address people should open.";
        else { payload = u; summary = u; }
        break;
      }
      case "text": {
        var t = trim(f.text);
        if (!t) errors.text = "Enter the text you want the code to show.";
        else { payload = t; summary = t.length > 80 ? t.slice(0, 77) + "…" : t; }
        break;
      }
      case "email": {
        var e = trim(f.email);
        if (!validEmail(e)) errors.email = e ? "Check the email address — it should look like name@example.com" : "Enter the email address.";
        else {
          var q = [];
          if (trim(f.subject)) q.push("subject=" + encodeURIComponent(trim(f.subject)));
          if (trim(f.body)) q.push("body=" + encodeURIComponent(trim(f.body)));
          payload = "mailto:" + e + (q.length ? "?" + q.join("&") : "");
          summary = "Email " + e;
        }
        break;
      }
      case "phone": {
        var p = normalizePhone(f.phone);
        if (!p) errors.phone = "Enter a phone number with at least 5 digits. Include the country code (+1) so it works for every caller.";
        else { payload = "tel:" + p; summary = "Call " + p; }
        break;
      }
      case "sms": {
        var sp = normalizePhone(f.phone);
        if (!sp) errors.phone = "Enter the phone number that should receive the text.";
        else { payload = "SMSTO:" + sp + ":" + trim(f.message); summary = "Text " + sp; }
        break;
      }
      case "wifi": {
        var ssid = trim(f.ssid), sec = f.security || "WPA", pw = f.password || "";
        if (!ssid) errors.ssid = "Enter your network name exactly as it appears on your router.";
        if (sec !== "nopass" && !pw) errors.password = "Enter the Wi-Fi password, or choose “No password” for an open network.";
        if (!Object.keys(errors).length) {
          payload = "WIFI:T:" + sec + ";S:" + wifiEscape(ssid) + ";" + (sec === "nopass" ? "" : "P:" + wifiEscape(pw) + ";") + (f.hidden ? "H:true;" : "") + ";";
          summary = "Wi-Fi network “" + ssid + "” (" + (sec === "nopass" ? "open" : sec + ", password hidden") + ")";
        }
        break;
      }
      case "vcard": {
        var first = trim(f.first), last = trim(f.last);
        if (!first && !last) errors.first = "Enter at least a first or last name.";
        var vemail = trim(f.email), vurl = trim(f.url);
        if (vemail && !validEmail(vemail)) errors.email = "Check the email address.";
        var nurl = vurl ? normalizeUrl(vurl) : "";
        if (vurl && !nurl) errors.url = "Check the website address.";
        if (!Object.keys(errors).length) {
          var L = ["BEGIN:VCARD", "VERSION:3.0",
            "N:" + vEsc(last) + ";" + vEsc(first) + ";;;",
            "FN:" + vEsc(trim(first + " " + last))];
          if (trim(f.org)) L.push("ORG:" + vEsc(trim(f.org)));
          if (trim(f.title)) L.push("TITLE:" + vEsc(trim(f.title)));
          var vp = normalizePhone(f.phone); if (vp) L.push("TEL;TYPE=CELL,VOICE:" + vp);
          if (vemail) L.push("EMAIL;TYPE=INTERNET:" + vemail);
          if (nurl) L.push("URL:" + nurl);
          if (trim(f.street) || trim(f.city) || trim(f.state) || trim(f.zip) || trim(f.country)) {
            L.push("ADR;TYPE=WORK:;;" + vEsc(trim(f.street)) + ";" + vEsc(trim(f.city)) + ";" + vEsc(trim(f.state)) + ";" + vEsc(trim(f.zip)) + ";" + vEsc(trim(f.country)));
          }
          L.push("END:VCARD");
          payload = L.join("\r\n");
          summary = "Contact card for " + trim(first + " " + last) + (trim(f.org) ? " (" + trim(f.org) + ")" : "");
        }
        break;
      }
    }
    return { payload: payload, errors: errors, summary: summary };
  }

  /* ══ 4. QR encoding ══ */
  function encode(payload) {
    var q = qrlib(0, S.ecc);
    q.addData(payload, "Byte");
    q.make();
    return q;
  }

  /* Draw the QR symbol with quiet zone into a square of side `side` px at
     (x,y). Integer-aligned module edges keep the print geometrically clean. */
  function drawQR(ctx, q, x, y, side, fg, bg) {
    var n = q.getModuleCount(), total = n + 8;
    var m = side / total;
    if (bg) { ctx.fillStyle = bg; ctx.fillRect(x, y, side, side); }
    ctx.fillStyle = fg;
    for (var r = 0; r < n; r++) {
      for (var c = 0; c < n; c++) {
        if (!q.isDark(r, c)) continue;
        var px = x + (c + 4) * m, py = y + (r + 4) * m;
        /* snap to device pixels; overlap by a hair to avoid seams */
        var x0 = Math.round(px), y0 = Math.round(py), x1 = Math.round(px + m), y1 = Math.round(py + m);
        ctx.fillRect(x0, y0, Math.max(1, x1 - x0), Math.max(1, y1 - y0));
      }
    }
  }

  /* ══ 5. Layout engine (inches) ══
     Returns geometry for the sticker at its real size so preview and export
     stay identical. All coordinates are inches from the sticker's top-left. */
  function computeLayout() {
    var shape = S.shape, W = S.w, H = S.h, m = SAFE_MARGIN_IN;
    var hasLogo = !!S.logo, hasCap = S.captionEnabled && !!trim(S.caption);
    var contentBox;
    if (shape === "circle" || shape === "oval") {
      /* largest inscribed rectangle sharing the ellipse's aspect: sides/√2 */
      var rw = (W - 2 * m) / Math.SQRT2, rh = (H - 2 * m) / Math.SQRT2;
      contentBox = { x: (W - rw) / 2, y: (H - rh) / 2, w: rw, h: rh };
    } else {
      contentBox = { x: m, y: m, w: W - 2 * m, h: H - 2 * m };
    }
    var wide = contentBox.w / contentBox.h > 1.25;
    var mode = S.layout === "auto" ? (wide ? "side" : "stack") : S.layout;
    if (!hasLogo && !hasCap) mode = "stack";

    var capH = hasCap ? Math.max(0.18, Math.min(0.32, Math.min(W, H) * 0.11)) : 0;
    var gap = 0.06;
    var g = { contentBox: contentBox, mode: mode, qr: null, logo: null, caption: null, capFont: capH * 0.62 };

    if (mode === "side") {
      /* QR on the right, logo + caption column on the left */
      var qrSide = Math.min(contentBox.h, contentBox.w * 0.55);
      g.qr = { x: contentBox.x + contentBox.w - qrSide, y: contentBox.y + (contentBox.h - qrSide) / 2, s: qrSide };
      var colW = contentBox.w - qrSide - gap * 2, colX = contentBox.x;
      var colH = contentBox.h;
      var logoH = hasLogo ? colH - capH - (hasCap ? gap : 0) : 0;
      if (hasLogo) g.logo = { x: colX, y: contentBox.y, w: colW, h: logoH };
      if (hasCap) g.caption = { x: colX, y: contentBox.y + colH - capH, w: colW, h: capH, align: "left" };
      g.capFont = Math.min(g.capFont, capH * 0.62);
    } else {
      /* vertical stack: logo / QR / caption */
      var logoH2 = hasLogo ? Math.max(0.3, Math.min(contentBox.h * 0.22, 1.2)) : 0;
      var avail = contentBox.h - logoH2 - capH - (hasLogo ? gap : 0) - (hasCap ? gap : 0);
      var qs = Math.min(contentBox.w, avail);
      var top = contentBox.y + (contentBox.h - (logoH2 + (hasLogo ? gap : 0) + qs + (hasCap ? gap : 0) + capH)) / 2;
      if (hasLogo) { g.logo = { x: contentBox.x, y: top, w: contentBox.w, h: logoH2 }; top += logoH2 + gap; }
      g.qr = { x: contentBox.x + (contentBox.w - qs) / 2, y: top, s: qs }; top += qs + (hasCap ? gap : 0);
      if (hasCap) g.caption = { x: contentBox.x, y: top, w: contentBox.w, h: capH, align: "center" };
    }
    /* Die/kiss cut: the sticker outline is a rounded badge hugging the
       content, not the full bounding box. */
    if (SHAPES[shape].box) {
      var pad = 0.12;
      var minX = g.qr.x, minY = g.qr.y, maxX = g.qr.x + g.qr.s, maxY = g.qr.y + g.qr.s;
      [g.logo, g.caption].forEach(function (b) { if (!b) return; minX = Math.min(minX, b.x); minY = Math.min(minY, b.y); maxX = Math.max(maxX, b.x + b.w); maxY = Math.max(maxY, b.y + b.h); });
      g.badge = { x: minX - pad, y: minY - pad, w: maxX - minX + 2 * pad, h: maxY - minY + 2 * pad, r: 0.18 };
      /* clamp inside the box */
      g.badge.x = Math.max(0, g.badge.x); g.badge.y = Math.max(0, g.badge.y);
      g.badge.w = Math.min(W - g.badge.x, g.badge.w); g.badge.h = Math.min(H - g.badge.y, g.badge.h);
    }
    g.moduleIn = S.qr ? g.qr.s / (S.qr.getModuleCount() + 8) : 0;
    return g;
  }

  /* ══ 6. Rasterizer — shared by preview and export ══
     `ppi` = pixels per inch. For die/kiss cut the canvas is cropped to the
     badge so the customizer's contour engine traces the badge edge. */
  function render(ppi, opts) {
    opts = opts || {};
    var g = computeLayout();
    var shape = S.shape, box = SHAPES[shape].box;
    var ox = 0, oy = 0, cw = S.w, ch = S.h;
    if (box && g.badge && !opts.fullBox) { ox = g.badge.x; oy = g.badge.y; cw = g.badge.w; ch = g.badge.h; }
    var canvas = document.createElement("canvas");
    canvas.width = Math.round(cw * ppi); canvas.height = Math.round(ch * ppi);
    var ctx = canvas.getContext("2d");
    var X = function (v) { return (v - ox) * ppi; }, Y = function (v) { return (v - oy) * ppi; }, L = function (v) { return v * ppi; };

    /* sticker body */
    ctx.save();
    var outline = new Path2D();
    if (shape === "circle" || shape === "oval") outline.ellipse(X(S.w / 2), Y(S.h / 2), L(S.w / 2), L(S.h / 2), 0, 0, Math.PI * 2);
    else if (box && g.badge) { var b = g.badge; roundRect(outline, X(b.x), Y(b.y), L(b.w), L(b.h), L(b.r)); }
    else roundRect(outline, 0, 0, L(S.w), L(S.h), L(0.12));
    if (opts.checker) {
      var t = Math.max(8, Math.round(ppi / 8));
      for (var yy = 0; yy < canvas.height; yy += t) for (var xx = 0; xx < canvas.width; xx += t) { ctx.fillStyle = ((xx / t + yy / t) % 2) ? "#e3e3e3" : "#efefef"; ctx.fillRect(xx, yy, t, t); }
    }
    ctx.clip(outline);
    ctx.fillStyle = S.bg; ctx.fillRect(0, 0, canvas.width, canvas.height);

    /* logo */
    if (g.logo && S.logo) {
      var lb = g.logo, iw = S.logo.naturalWidth || 1, ih = S.logo.naturalHeight || 1;
      var sc = Math.min(L(lb.w) / iw, L(lb.h) / ih), dw = iw * sc, dh = ih * sc;
      var lx = g.mode === "side" ? X(lb.x) : X(lb.x) + (L(lb.w) - dw) / 2;
      ctx.imageSmoothingEnabled = true; ctx.imageSmoothingQuality = "high";
      ctx.drawImage(S.logo, lx, Y(lb.y) + (L(lb.h) - dh) / 2, dw, dh);
    }
    /* caption */
    if (g.caption && trim(S.caption)) {
      var cb = g.caption, fs = L(g.capFont);
      ctx.fillStyle = INK; ctx.textBaseline = "middle"; ctx.textAlign = cb.align;
      ctx.font = "700 " + fs + "px " + headingFont();
      var text = trim(S.caption).toUpperCase(), maxW = L(cb.w);
      while (ctx.measureText(text).width > maxW && fs > L(0.08)) { fs *= 0.94; ctx.font = "700 " + fs + "px " + headingFont(); }
      var tx = cb.align === "left" ? X(cb.x) : X(cb.x) + L(cb.w) / 2;
      ctx.fillText(text, tx, Y(cb.y) + L(cb.h) / 2);
    }
    /* QR — drawn last, on a solid background square so nothing can sit on it */
    if (S.qr) drawQR(ctx, S.qr, X(g.qr.x), Y(g.qr.y), L(g.qr.s), INK, S.bg);
    ctx.restore();

    if (opts.guides) {
      ctx.save(); ctx.setLineDash([6, 5]); ctx.lineWidth = 1.5; ctx.strokeStyle = "#D40067"; ctx.stroke(outline);
      ctx.setLineDash([4, 4]); ctx.strokeStyle = "#006A8E"; ctx.lineWidth = 1;
      ctx.strokeRect(X(g.qr.x), Y(g.qr.y), L(g.qr.s), L(g.qr.s));
      ctx.restore();
    }
    return { canvas: canvas, geometry: g, widthIn: cw, heightIn: ch };
  }
  function roundRect(p, x, y, w, h, r) {
    r = Math.min(r, w / 2, h / 2);
    p.moveTo(x + r, y); p.lineTo(x + w - r, y); p.quadraticCurveTo(x + w, y, x + w, y + r);
    p.lineTo(x + w, y + h - r); p.quadraticCurveTo(x + w, y + h, x + w - r, y + h);
    p.lineTo(x + r, y + h); p.quadraticCurveTo(x, y + h, x, y + h - r);
    p.lineTo(x, y + r); p.quadraticCurveTo(x, y, x + r, y); p.closePath();
  }
  function headingFont() {
    var v = getComputedStyle(document.documentElement).getPropertyValue("--font-heading-family");
    return (v && v.trim()) || '"Bricolage Grotesque","Arial Black",sans-serif';
  }

  /* ══ 7. Preview ══ */
  var previewCanvas = $("qr-preview-canvas");
  function drawPreview() {
    if (!previewCanvas) return;
    var wrap = previewCanvas.parentElement, size = Math.max(240, Math.min(wrap.clientWidth || 440, 520));
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var ppi = (size / Math.max(S.w, S.h)) * dpr;
    var out = render(ppi, { checker: true, guides: true });
    previewCanvas.width = out.canvas.width; previewCanvas.height = out.canvas.height;
    previewCanvas.style.width = (out.canvas.width / dpr) + "px"; previewCanvas.style.height = (out.canvas.height / dpr) + "px";
    previewCanvas.getContext("2d").drawImage(out.canvas, 0, 0);
    var note = $("qr-preview-note");
    if (note) note.textContent = fmtIn(out.widthIn) + '" × ' + fmtIn(out.heightIn) + '" • ' + SHAPES[S.shape].label + (SHAPES[S.shape].box ? " (inside " + S.sizeValue.replace("Up to ", "") + ")" : "") + " • " + (S.qr ? S.qr.getModuleCount() + "×" + S.qr.getModuleCount() + " modules" : "no code yet");
    updateSizeWarning(out.geometry);
  }
  function fmtIn(v) { return (Math.round(v * 100) / 100).toString(); }

  function updateSizeWarning(g) {
    var el = $("qr-size-warn"); if (!el) return;
    if (!S.qr) { el.hidden = true; return; }
    var mm = g.moduleIn * 25.4;
    if (g.moduleIn < MIN_MODULE_IN) {
      el.hidden = false;
      el.textContent = "At this size each QR module is about " + mm.toFixed(2) + " mm — too fine for reliable scanning (0.4 mm or larger is recommended). Choose a bigger sticker, shorten the content, or remove the logo/caption.";
    } else el.hidden = true;
  }

  /* ══ 8. Scan self-test (honest: only claims verified after a real decode) ══ */
  var detector = null;
  try { if ("BarcodeDetector" in window) detector = new window.BarcodeDetector({ formats: ["qr_code"] }); } catch (e) { detector = null; }
  var testSeq = 0;
  function selfTest() {
    var status = $("qr-status"), badge = $("qr-status-badge"); if (!status) return;
    if (!S.qr) { badge.className = "qr-status__badge"; badge.textContent = "Waiting for content"; status.textContent = "Fill in the details on the left to generate your code."; return; }
    if (!detector) {
      badge.className = "qr-status__badge is-ready"; badge.textContent = "QR code ready";
      status.textContent = "Scan the preview with your phone to confirm it opens what you expect. Always test a printed sticker before handing them out.";
      return;
    }
    var seq = ++testSeq;
    badge.className = "qr-status__badge"; badge.textContent = "Checking…";
    var out = render(150, {});
    detector.detect(out.canvas).then(function (codes) {
      if (seq !== testSeq) return;
      var hit = codes && codes.some(function (c) { return c.rawValue === S.payload; });
      S.verified = !!hit;
      if (hit) { badge.className = "qr-status__badge is-verified"; badge.textContent = "Decoded in your browser ✓"; status.textContent = "Your browser read the code back and it matches what you entered. Still test a printed sticker before handing them out."; }
      else { badge.className = "qr-status__badge is-ready"; badge.textContent = "QR code ready"; status.textContent = "Couldn't auto-read the preview at this size — that's common for dense codes. Scan it with your phone to confirm, and always test a printed sticker."; }
    }).catch(function () {
      if (seq !== testSeq) return;
      badge.className = "qr-status__badge is-ready"; badge.textContent = "QR code ready";
      status.textContent = "Scan the preview with your phone to confirm it opens what you expect. Always test a printed sticker before handing them out.";
    });
  }

  /* ══ 9. Form rendering ══ */
  function renderFields() {
    var host = $("qr-fields"); host.innerHTML = "";
    (FIELD_DEFS[S.qrType] || []).forEach(function (d) {
      var id = "qrf-" + d[0], wrap = document.createElement("div"); wrap.className = "qr-field";
      var val = S.fields[d[0]] == null ? "" : S.fields[d[0]];
      if (d[2] === "checkbox") {
        wrap.className += " qr-field--check";
        wrap.innerHTML = '<label class="qr-check"><input type="checkbox" id="' + id + '"' + (val ? " checked" : "") + '><span>' + d[1] + '</span></label>';
      } else if (d[2] === "select") {
        var opts = ""; for (var i = 0; i < d[3].length; i += 2) opts += '<option value="' + d[3][i] + '"' + ((val || "WPA") === d[3][i] ? " selected" : "") + ">" + d[3][i + 1] + "</option>";
        wrap.innerHTML = '<label for="' + id + '">' + d[1] + '</label><select id="' + id + '" class="qr-input">' + opts + "</select>";
      } else if (d[2] === "textarea") {
        wrap.innerHTML = '<label for="' + id + '">' + d[1] + (d[4] ? "" : ' <span class="qr-opt">optional</span>') + '</label><textarea id="' + id + '" class="qr-input" rows="3" placeholder="' + esc(d[3]) + '"></textarea><p class="qr-field__err" id="' + id + '-err" hidden></p>';
        wrap.querySelector("textarea").value = val;
      } else {
        var type = d[2] === "password" ? "password" : (d[2] === "url" ? "text" : d[2]);
        wrap.innerHTML = '<label for="' + id + '">' + d[1] + (d[4] ? "" : ' <span class="qr-opt">optional</span>') + '</label><input id="' + id + '" class="qr-input" type="' + type + '" inputmode="' + (d[2] === "tel" ? "tel" : d[2] === "email" ? "email" : d[2] === "url" ? "url" : "text") + '" placeholder="' + esc(d[3]) + '" autocomplete="' + (d[2] === "password" ? "off" : "on") + '"' + (d[2] === "url" ? ' spellcheck="false" autocapitalize="off"' : "") + '><p class="qr-field__err" id="' + id + '-err" hidden></p>';
        wrap.querySelector("input").value = val;
      }
      host.appendChild(wrap);
      var input = wrap.querySelector("input,select,textarea");
      input.addEventListener("input", function () { S.fields[d[0]] = input.type === "checkbox" ? input.checked : input.value; scheduleUpdate(); });
      input.addEventListener("change", function () { S.fields[d[0]] = input.type === "checkbox" ? input.checked : input.value; scheduleUpdate(); });
    });
    var note = $("qr-type-note");
    if (note) note.textContent = S.qrType === "wifi" ? "The password is stored inside the QR code itself — anyone who scans the sticker can join. Put these where only guests can see them." : S.qrType === "vcard" ? "Scanning opens a “save contact” prompt on most phones." : S.qrType === "url" ? "Static code: it always opens this exact address. If the page moves later, you'll need a new sticker." : "";
  }
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]; }); }

  function showErrors(errors) {
    (FIELD_DEFS[S.qrType] || []).forEach(function (d) {
      var input = $("qrf-" + d[0]), err = $("qrf-" + d[0] + "-err"); if (!input || !err) return;
      var msg = errors[d[0]];
      err.hidden = !msg; err.textContent = msg || "";
      input.setAttribute("aria-invalid", msg ? "true" : "false");
      if (msg) input.setAttribute("aria-describedby", err.id); else input.removeAttribute("aria-describedby");
    });
  }

  /* ══ 10. Update pipeline ══ */
  var updateTimer = null, touched = false;
  function scheduleUpdate() { touched = true; clearTimeout(updateTimer); updateTimer = setTimeout(update, 180); }
  function update() {
    var res = buildPayload(S.qrType, S.fields);
    var anyInput = Object.keys(S.fields).some(function (k) { return trim(S.fields[k]) !== "" && S.fields[k] !== false; });
    showErrors(anyInput ? res.errors : {});
    var capacityErr = $("qr-capacity-err");
    if (res.payload) {
      try { S.qr = encode(res.payload); S.payload = res.payload; S.summary = res.summary; capacityErr.hidden = true; }
      catch (e) { S.qr = null; S.payload = ""; capacityErr.hidden = false; capacityErr.textContent = "That's more than a QR code can hold — shorten the text and try again."; }
    } else { S.qr = null; S.payload = ""; }
    drawPreview(); selfTest(); updateButtons(); saveState();
  }
  function updateButtons() {
    var on = !!S.qr;
    ["qr-dl-png", "qr-dl-svg", "qr-dl-design", "qr-order"].forEach(function (id) { var b = $(id); if (b) b.disabled = !on; });
    var orderLbl = $("qr-order-label"), prod = PRODUCTS[S.shape];
    if (orderLbl) orderLbl.textContent = on ? "Order " + SHAPES[S.shape].label.toLowerCase() + " stickers" + (prod && prod.from ? " — from " + prod.from : "") : "Generate a QR code to order";
  }

  /* ══ 11. Downloads ══ */
  /* v1.1: attribution. crc32/pngWithText embed tEXt metadata chunks into the
     exported PNG bytes (pixels untouched); the SVG gains a deletable Info
     line OUTSIDE the QR quiet zone. Free downloads only — the order
     hand-off is byte-identical to v1.0. */
  var PNG_META = [
    ["Software", "Grabatee QR Sticker Studio (free) - grabatee.com"],
    ["Comment", "Free QR code made at grabatee.com/pages/qr-code-stickers"]
  ];
  function crc32(bytes, start, end) {
    var table = crc32.t;
    if (!table) {
      table = crc32.t = [];
      for (var n = 0; n < 256; n++) { var c = n; for (var k = 0; k < 8; k++) c = (c & 1) ? (0xEDB88320 ^ (c >>> 1)) : (c >>> 1); table[n] = c >>> 0; }
    }
    var c = 0xFFFFFFFF;
    for (var i = start; i < end; i++) c = table[(c ^ bytes[i]) & 0xFF] ^ (c >>> 8);
    return (c ^ 0xFFFFFFFF) >>> 0;
  }
  function pngWithText(bytes, pairs) {
    /* every valid PNG starts sig(8) + IHDR chunk(25); insert tEXt at offset 33 */
    var chunks = [];
    pairs.forEach(function (p) {
      var data = p[0] + "\0" + p[1], n = data.length, ch = new Uint8Array(12 + n);
      ch[0] = (n >>> 24) & 255; ch[1] = (n >>> 16) & 255; ch[2] = (n >>> 8) & 255; ch[3] = n & 255;
      ch[4] = 116; ch[5] = 69; ch[6] = 88; ch[7] = 116;
      for (var i = 0; i < n; i++) ch[8 + i] = data.charCodeAt(i) & 255;
      var crc = crc32(ch, 4, 8 + n);
      ch[8 + n] = (crc >>> 24) & 255; ch[9 + n] = (crc >>> 16) & 255; ch[10 + n] = (crc >>> 8) & 255; ch[11 + n] = crc & 255;
      chunks.push(ch);
    });
    var extra = chunks.reduce(function (a, c) { return a + c.length; }, 0);
    var out = new Uint8Array(bytes.length + extra);
    out.set(bytes.subarray(0, 33), 0);
    var pos = 33;
    chunks.forEach(function (c) { out.set(c, pos); pos += c.length; });
    out.set(bytes.subarray(33), pos);
    return out;
  }
  function pngMetaBlob(canvas, cb) {
    try {
      var b64 = canvas.toDataURL("image/png").split(",")[1], bin = atob(b64), bytes = new Uint8Array(bin.length);
      for (var i = 0; i < bin.length; i++) bytes[i] = bin.charCodeAt(i);
      cb(new Blob([pngWithText(bytes, PNG_META)], { type: "image/png" }));
    } catch (e) { canvas.toBlob(function (b) { cb(b); }, "image/png"); }
  }
  function download(blob, name) {
    var a = document.createElement("a"); a.href = URL.createObjectURL(blob); a.download = name;
    document.body.appendChild(a); a.click(); document.body.removeChild(a);
    setTimeout(function () { URL.revokeObjectURL(a.href); }, 4000);
  }
  function qrOnlyCanvas(scale) {
    var n = S.qr.getModuleCount() + 8, c = document.createElement("canvas");
    c.width = c.height = n * scale;
    drawQR(c.getContext("2d"), S.qr, 0, 0, n * scale, "#000000", "#FFFFFF");
    return c;
  }
  function downloadPNG() {
    if (!S.qr) return;
    pngMetaBlob(qrOnlyCanvas(24), function (b) { if (b) download(b, "grabatee-qr-code.png"); });
  }
  function downloadSVG() {
    if (!S.qr) return;
    var n = S.qr.getModuleCount(), t = n + 8, d = "";
    for (var r = 0; r < n; r++) for (var c = 0; c < n; c++) if (S.qr.isDark(r, c)) d += "M" + (c + 4) + " " + (r + 4) + "h1v1h-1z";
    var th = t + 3;
    var svg = '<?xml version="1.0" encoding="UTF-8"?>\n<!-- Free static QR code from the Grabatee QR Sticker Studio - grabatee.com/pages/qr-code-stickers. The #Info line sits outside the QR quiet zone - delete that group if you do not want the credit. -->\n<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ' + t + " " + th + '" width="' + t * 10 + '" height="' + th * 10 + '"><rect width="' + t + '" height="' + t + '" fill="#fff" shape-rendering="crispEdges"/><path d="' + d + '" fill="#000" shape-rendering="crispEdges"/>\n<g id="Info"><text x="' + (t / 2) + '" y="' + (t + 1.9) + '" text-anchor="middle" font-size="1.15" font-family="Arial, Helvetica, sans-serif" fill="#8A8A8A">Free QR code \u2014 grabatee.com</text></g>\n</svg>';
    download(new Blob([svg], { type: "image/svg+xml" }), "grabatee-qr-code.svg");
  }
  function downloadDesign() {
    if (!S.qr) return;
    pngMetaBlob(render(EXPORT_DPI, {}).canvas, function (b) { if (b) download(b, "grabatee-qr-sticker-design.png"); });
  }

  /* ══ 12. Hand-off to the sticker product page ══ */
  function handoff() {
    if (!S.qr) return;
    var prod = PRODUCTS[S.shape], err = $("qr-order-err");
    if (!prod || !prod.url) { err.hidden = false; err.textContent = "This sticker shape isn't linked to a product yet. Please contact us or choose another shape."; return; }
    var btn = $("qr-order"); btn.disabled = true; $("qr-order-label").textContent = "Preparing your design…";
    var dpi = EXPORT_DPI, dataURL = "";
    for (var attempt = 0; attempt < 3; attempt++) {
      dataURL = render(dpi, {}).canvas.toDataURL("image/png");
      if (dataURL.length < 4200000) break;
      dpi = attempt === 0 ? 200 : 150;
    }
    var payload = {
      v: 1, created: Date.now(), type: S.shape, sizeValue: S.sizeValue,
      fileName: "qr-sticker-" + S.shape + "-" + S.sizeValue.replace(/[^0-9a-z.]/gi, "") + ".png",
      dpi: dpi, dataURL: dataURL,
      qrType: TYPE_LABELS[S.qrType], qrSummary: S.summary || "",
      verified: S.verified === true
    };
    try {
      window.sessionStorage.setItem("grabQrHandoff", JSON.stringify(payload));
    } catch (e) {
      btn.disabled = false; updateButtons();
      err.hidden = false; err.textContent = "Your browser blocked saving the design for the next step. Download the sticker design below and upload it on the product page instead.";
      return;
    }
    window.location.href = prod.url + (prod.url.indexOf("?") > -1 ? "&" : "?") + "qr=1";
  }

  /* ══ 13. Shape / size / logo / caption / background controls ══ */
  function buildShapes() {
    var host = $("qr-shapes"); host.innerHTML = "";
    Object.keys(SHAPES).forEach(function (k) {
      var b = document.createElement("button"); b.type = "button"; b.className = "qr-shape" + (k === S.shape ? " active" : "");
      b.setAttribute("aria-pressed", k === S.shape ? "true" : "false"); b.dataset.shape = k;
      b.innerHTML = shapeIcon(k) + "<span>" + SHAPES[k].label + "</span>" + (PRODUCTS[k] && PRODUCTS[k].from ? '<small>from ' + PRODUCTS[k].from + "</small>" : "");
      b.addEventListener("click", function () { setShape(k); });
      host.appendChild(b);
    });
  }
  function shapeIcon(k) {
    var s = 'viewBox="0 0 40 40" width="30" height="30" aria-hidden="true"';
    switch (k) {
      case "circle": return '<svg ' + s + '><circle cx="20" cy="20" r="16" fill="currentColor" opacity=".18" stroke="currentColor" stroke-width="1.5"/></svg>';
      case "oval": return '<svg ' + s + '><ellipse cx="20" cy="20" rx="17" ry="11" fill="currentColor" opacity=".18" stroke="currentColor" stroke-width="1.5"/></svg>';
      case "rectangle": return '<svg ' + s + '><rect x="3" y="10" width="34" height="20" rx="4" fill="currentColor" opacity=".18" stroke="currentColor" stroke-width="1.5"/></svg>';
      case "die-cut": return '<svg ' + s + '><path d="M20 4 33 10 37 26 27 36 11 35 4 21Z" fill="currentColor" opacity=".18" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/></svg>';
      case "kiss-cut": return '<svg ' + s + '><rect x="3" y="3" width="34" height="34" rx="4" fill="currentColor" opacity=".1" stroke="currentColor" stroke-width="1.5"/><rect x="10" y="10" width="20" height="20" rx="2" fill="none" stroke="currentColor" stroke-width="1" stroke-dasharray="3 2"/></svg>';
      default: return '<svg ' + s + '><rect x="4" y="4" width="32" height="32" rx="4" fill="currentColor" opacity=".18" stroke="currentColor" stroke-width="1.5"/></svg>';
    }
  }
  function setShape(k) {
    if (!SHAPES[k]) return;
    var idx = Math.max(0, SHAPES[S.shape].sizes.findIndex(function (s) { return s[0] === S.sizeValue; }));
    S.shape = k;
    var sz = SHAPES[k].sizes[idx] || SHAPES[k].sizes[DEFAULT_SIZE_INDEX];
    S.sizeValue = sz[0]; S.w = sz[1]; S.h = sz[2];
    document.querySelectorAll("#qr-shapes .qr-shape").forEach(function (b) { var on = b.dataset.shape === k; b.classList.toggle("active", on); b.setAttribute("aria-pressed", on ? "true" : "false"); });
    var hint = $("qr-shape-hint");
    if (hint) hint.textContent = SHAPES[k].box ? (k === "die-cut" ? "Die cut: the sticker is cut to a rounded badge around your code — no extra background." : "Kiss cut: a rounded badge on a square backing that peels off easily.") : "The QR code stays square — only the sticker outline changes.";
    buildSizes(); drawPreview(); updateButtons(); saveState();
  }
  function buildSizes() {
    var host = $("qr-sizes"); host.innerHTML = "";
    SHAPES[S.shape].sizes.forEach(function (s) {
      var b = document.createElement("button"); b.type = "button"; b.className = "qr-size" + (s[0] === S.sizeValue ? " active" : "");
      b.setAttribute("aria-pressed", s[0] === S.sizeValue ? "true" : "false");
      b.textContent = (SHAPES[S.shape].box ? "Up to " : "") + s[1] + '" × ' + s[2] + '"';
      b.addEventListener("click", function () { S.sizeValue = s[0]; S.w = s[1]; S.h = s[2]; buildSizes(); drawPreview(); saveState(); });
      host.appendChild(b);
    });
  }
  function buildSwatches() {
    var host = $("qr-bg-swatches"); host.innerHTML = "";
    BG_SWATCHES.forEach(function (c) {
      var b = document.createElement("button"); b.type = "button"; b.className = "qr-swatch" + (c.toUpperCase() === S.bg.toUpperCase() ? " active" : "");
      b.style.background = c; b.setAttribute("aria-label", "Background " + c); b.setAttribute("aria-pressed", c.toUpperCase() === S.bg.toUpperCase() ? "true" : "false");
      b.addEventListener("click", function () { setBg(c); });
      host.appendChild(b);
    });
  }
  function luminance(hex) {
    var c = hex.replace("#", ""); if (c.length === 3) c = c.split("").map(function (x) { return x + x; }).join("");
    var r = parseInt(c.slice(0, 2), 16) / 255, g = parseInt(c.slice(2, 4), 16) / 255, b = parseInt(c.slice(4, 6), 16) / 255;
    var f = function (v) { return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4); };
    return 0.2126 * f(r) + 0.7152 * f(g) + 0.0722 * f(b);
  }
  function setBg(c) {
    var err = $("qr-bg-err");
    /* Contrast with the ink modules must stay high for scanners: ≥ 7:1 */
    var ratio = (luminance(c) + 0.05) / (luminance(INK) + 0.05);
    if (ratio < 7) { err.hidden = false; err.textContent = "That background is too dark for a scannable code — pick a light color."; return; }
    err.hidden = true; S.bg = c.toUpperCase();
    var custom = $("qr-bg-custom"); if (custom && custom.value.toUpperCase() !== S.bg) custom.value = S.bg;
    buildSwatches(); drawPreview(); saveState();
  }

  var LOGO_RE = /\.(png|jpe?g|svg|webp)$/i, LOGO_TYPES = ["image/png", "image/jpeg", "image/svg+xml", "image/webp"];
  function handleLogo(file) {
    var err = $("qr-logo-err");
    if (!file) return;
    if (!(LOGO_RE.test(file.name) || LOGO_TYPES.indexOf(file.type) > -1)) { err.hidden = false; err.textContent = "Use a PNG, JPG, SVG, or WEBP file. (PDF isn't supported here — export your logo as PNG or SVG first.)"; return; }
    if (file.size > 15 * 1024 * 1024) { err.hidden = false; err.textContent = "That file is over 15 MB — please use a smaller version."; return; }
    err.hidden = true;
    var reader = new FileReader();
    reader.onerror = function () { err.hidden = false; err.textContent = "Couldn't read that file. Try a PNG or JPG."; };
    reader.onload = function (ev) {
      var img = new Image();
      img.onerror = function () { err.hidden = false; err.textContent = "Couldn't load that image. Try a PNG or JPG."; };
      img.onload = function () {
        S.logo = img; S.logoName = file.name; S.logoDataURL = ev.target.result;
        $("qr-logo-name").textContent = file.name; $("qr-logo-has").hidden = false; $("qr-logo-idle").hidden = true;
        drawPreview(); saveState();
      };
      img.src = ev.target.result;
    };
    reader.readAsDataURL(file);
  }
  function removeLogo() {
    S.logo = null; S.logoName = ""; S.logoDataURL = "";
    $("qr-logo-has").hidden = true; $("qr-logo-idle").hidden = false; $("qr-logo-input").value = "";
    drawPreview(); saveState();
  }

  /* ══ 14. Session persistence (this tab only; passwords never stored) ══ */
  function saveState() {
    try {
      var f = {}; Object.keys(S.fields).forEach(function (k) { if (k !== "password") f[k] = S.fields[k]; });
      window.sessionStorage.setItem("grabQrStudio", JSON.stringify({ qrType: S.qrType, fields: f, shape: S.shape, sizeValue: S.sizeValue, caption: S.caption, captionEnabled: S.captionEnabled, bg: S.bg, layout: S.layout, logoDataURL: S.logoDataURL.length < 1500000 ? S.logoDataURL : "", logoName: S.logoName }));
    } catch (e) { /* storage full or disabled — harmless */ }
  }
  function restoreState() {
    try {
      var raw = window.sessionStorage.getItem("grabQrStudio"); if (!raw) return;
      var s = JSON.parse(raw);
      if (s.qrType && FIELD_DEFS[s.qrType]) S.qrType = s.qrType;
      S.fields = s.fields || {};
      if (s.shape && SHAPES[s.shape]) { S.shape = s.shape; var sz = SHAPES[s.shape].sizes.find(function (x) { return x[0] === s.sizeValue; }); if (sz) { S.sizeValue = sz[0]; S.w = sz[1]; S.h = sz[2]; } }
      S.caption = s.caption || ""; S.captionEnabled = s.captionEnabled !== false; if (s.bg) S.bg = s.bg; if (s.layout) S.layout = s.layout;
      if (s.logoDataURL) { var img = new Image(); img.onload = function () { S.logo = img; S.logoName = s.logoName || "logo"; S.logoDataURL = s.logoDataURL; $("qr-logo-name").textContent = S.logoName; $("qr-logo-has").hidden = false; $("qr-logo-idle").hidden = true; drawPreview(); }; img.src = s.logoDataURL; }
    } catch (e) { /* ignore corrupt state */ }
  }

  /* ══ 15. Init ══ */
  function init() {
    restoreState();
    /* type tabs */
    document.querySelectorAll("#qr-types .qr-type").forEach(function (b) {
      var on = b.dataset.type === S.qrType;
      b.classList.toggle("active", on); b.setAttribute("aria-selected", on ? "true" : "false"); b.setAttribute("tabindex", on ? "0" : "-1");
      b.addEventListener("click", function () {
        S.qrType = b.dataset.type; S.fields = {};
        document.querySelectorAll("#qr-types .qr-type").forEach(function (x) { var o = x === b; x.classList.toggle("active", o); x.setAttribute("aria-selected", o ? "true" : "false"); x.setAttribute("tabindex", o ? "0" : "-1"); });
        renderFields(); update();
        var first = $("qr-fields").querySelector("input,textarea,select"); if (first) first.focus();
      });
      b.addEventListener("keydown", function (e) {
        var tabs = Array.prototype.slice.call(document.querySelectorAll("#qr-types .qr-type")), i = tabs.indexOf(b);
        if (e.key === "ArrowRight" || e.key === "ArrowLeft") { e.preventDefault(); tabs[(i + (e.key === "ArrowRight" ? 1 : tabs.length - 1)) % tabs.length].focus(); }
        if (e.key === "Home") { e.preventDefault(); tabs[0].focus(); } if (e.key === "End") { e.preventDefault(); tabs[tabs.length - 1].focus(); }
      });
    });
    renderFields();
    buildShapes(); buildSizes(); buildSwatches();
    var hint = $("qr-shape-hint"); if (hint) hint.textContent = "The QR code stays square — only the sticker outline changes.";

    var cap = $("qr-caption"); if (cap) { cap.value = S.caption; cap.addEventListener("input", function () { S.caption = cap.value.slice(0, 40); drawPreview(); saveState(); }); }
    var capOn = $("qr-caption-on"); if (capOn) { capOn.checked = S.captionEnabled; capOn.addEventListener("change", function () { S.captionEnabled = capOn.checked; drawPreview(); saveState(); }); }
    var custom = $("qr-bg-custom"); if (custom) { custom.value = S.bg; custom.addEventListener("input", function () { setBg(custom.value); }); }
    document.querySelectorAll('input[name="qr-layout"]').forEach(function (r) { r.checked = r.value === S.layout; r.addEventListener("change", function () { if (r.checked) { S.layout = r.value; drawPreview(); saveState(); } }); });

    var zone = $("qr-logo-zone"), input = $("qr-logo-input");
    if (zone && input) {
      zone.addEventListener("click", function () { input.click(); });
      zone.addEventListener("keydown", function (e) { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); input.click(); } });
      zone.addEventListener("dragover", function (e) { e.preventDefault(); zone.classList.add("drag"); });
      zone.addEventListener("dragleave", function () { zone.classList.remove("drag"); });
      zone.addEventListener("drop", function (e) { e.preventDefault(); zone.classList.remove("drag"); if (e.dataTransfer.files[0]) handleLogo(e.dataTransfer.files[0]); });
      input.addEventListener("change", function () { if (input.files && input.files[0]) handleLogo(input.files[0]); });
    }
    var rm = $("qr-logo-remove"); if (rm) rm.addEventListener("click", function (e) { e.stopPropagation(); removeLogo(); });
    var rp = $("qr-logo-replace"); if (rp) rp.addEventListener("click", function (e) { e.stopPropagation(); input.click(); });

    $("qr-dl-png").addEventListener("click", downloadPNG);
    $("qr-dl-svg").addEventListener("click", downloadSVG);
    $("qr-dl-design").addEventListener("click", downloadDesign);
    $("qr-order").addEventListener("click", handoff);

    var ro = null;
    if ("ResizeObserver" in window) { ro = new ResizeObserver(function () { drawPreview(); }); ro.observe(previewCanvas.parentElement); }
    else window.addEventListener("resize", drawPreview);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(drawPreview);
    update();
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init); else init();
})();
